module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.$_onOutsideClick),
      expression: "$_onOutsideClick"
    }],
    class: _vm.classes,
    on: {
      "mouseenter": _vm.$_onTriggerMouseenter,
      "mouseleave": _vm.$_onTriggerMouseleave
    }
  }, [_c('div', {
    ref: "reference",
    class: [_vm.prefixCls + '-rel'],
    on: {
      "click": _vm.$_onButtonClick,
      "mousedown": function($event) {
        return _vm.onFocus(false)
      },
      "mouseup": function($event) {
        return _vm.onBlur(false)
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    ref: "popper",
    class: ['popover'],
    style: (_vm.styles),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$_stopClick($event)
      }
    }
  }, [_c('div', {
    class: [_vm.prefixCls + '-arrow']
  }), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-content']
  }, [(_vm.confirm && _vm.title) ? _c('h3', {
    class: [_vm.prefixCls + '-title'],
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.confirm) ? _c('div', {
    class: [_vm.prefixCls + '-inner']
  }, [_c('div', {
    class: [_vm.prefixCls + '-footer', 'text-right']
  }, [_c('t-button', {
    attrs: {
      "size": "sm"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeCancelText))]), _vm._v(" "), _c('t-button', {
    attrs: {
      "type": "primary",
      "size": "sm"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.ok($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeOkText))])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.confirm) ? _c('div', {
    class: [_vm.prefixCls + '-inner']
  }, [(_vm.showTitle) ? _c('div', {
    ref: "title",
    class: [_vm.prefixCls + '-title']
  }, [_vm._t("title", [_c('div', {
    class: [_vm.prefixCls + '-title-inner']
  }, [_vm._v(_vm._s(_vm.title))])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-body']
  }, [_c('div', {
    class: [_vm.prefixCls + '-body-content']
  }, [_vm._t("content", [_c('div', {
    class: [_vm.prefixCls + '-body-content-inner']
  }, [_vm._v(_vm._s(_vm.content))])])], 2)])]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c283fc2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/poptip/poptip.vue
// module id = 406
// module chunks = 0